import Container from "react-bootstrap/Container";

export default function About() {
  return (
    <section id="about" className="about background-alt">
      <Container data-aos="fade-up">
        <div className="section-title section-title-left">
          <span className="section-index">01 — Profile</span>
          <h2>Engineering across the full robot stack</h2>
        </div>
        <div className="about-grid">
          <div className="about-lead">
            <p>I am a robotics engineer focused on <span className="text-accent">autonomous driving</span>, <span className="text-accent text-nowrap">ROS 2 systems</span>, and the software that connects sensors to real machines.</p>
          </div>
          <div className="about-copy">
            <p>My work at the Vehicle Research Center in Győr covered ROS 1 and ROS 2, C++, Python, Gazebo, Foxglove, and sensor-driven autonomy for research vehicles.</p>
            <p>Today, at Kromberg &amp; Schubert, I work in automotive research and development—bringing a combined background in vehicle engineering, mechanical engineering, and software development to production-minded engineering problems.</p>
            <div className="focus-strip">
              <span>Perception</span><span>Localization</span><span>Simulation</span><span>Embedded systems</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
